import { useMemo } from 'react';

import { HeroImageData } from '@/components/hero-image';

export const useImageLayer = ({ images }: { images: HeroImageData[] }) => {
    const [imagesBack, imagesFront] = useMemo(
        () => [
            images.filter((image) => image.layer === 'back'),
            images.filter((image) => image.layer !== 'back'),
        ],
        [images],
    );

    return { imagesBack, imagesFront };
};
